import { Fragment, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Loading from 'components/loading/Loading'
import NoneAnchor from 'components/NoneAnchor'
import { fetchDashboardInfoCreative } from 'features/dashboard/info/dashboardInfoSlice'
import { CreativeTypes, OperationStatus } from 'features/Codes'
import { equalTo } from 'utils'
import Tooltip from 'components/tooltip/Tooltip'
import PropTypes from 'prop-types'
import { showCreativePreview } from 'features/dashboard/operation/creativePreview/creativePreviewSlice'
import { isNil } from 'lodash'

const CreativeDashboardTitleTooltip = ({ status }) => {
  const [first] = status
  return first ? (
    <Tooltip
      position="bottom"
      content={status.map((item, index) => (
        <Fragment key={index}>
          <strong className="tit_tooltip">운영 불가({item.title})</strong>
          <p className="txt_tooltip2">{item.msg}</p>
        </Fragment>
      ))}>
      운영 불가({first.title}){status.length > 1 ? `(${status.length})` : ''}
    </Tooltip>
  ) : null
}
CreativeDashboardTitleTooltip.propTypes = {
  status: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      msg: PropTypes.string,
    })
  ),
}

const CreativeInfo = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    visible,
    loaded,
    id: creativeLinkId,
    creative,
  } = useSelector(state => state.dashboard.info)
  const operationStatus = useMemo(() => {
    if (isNil(creative.operationStatus)) return []
    return creative.operationStatus.map(status => OperationStatus[status])
  }, [creative.operationStatus])

  useEffect(() => {
    if (visible && !loaded) {
      dispatch(fetchDashboardInfoCreative({ id: creativeLinkId }))
    }
  }, [dispatch, visible, loaded, creativeLinkId])

  return (
    <>
      <ul className="tab_g6">
        <li>
          <NoneAnchor
            className="link_tab fw_bold"
            style={{ cursor: 'default' }}>
            기본 정보
          </NoneAnchor>
        </li>
      </ul>
      {isLoading ? (
        <div style={{ height: 296 }}>
          <Loading />
        </div>
      ) : (
        <>
          {loaded && (
            <div className="tab_cont">
              <h4 className="screen_out">기본 정보</h4>
              <div className="infosum_dash">
                <table className="tbl_infosum">
                  <caption className="hide_caption">
                    기본 정보 데이터 테이블
                  </caption>
                  <colgroup>
                    <col />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <div className="inner_cell">ID</div>
                      </th>
                      <td>
                        <div className="inner_cell">{creativeLinkId}</div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <div className="inner_cell">상태</div>
                      </th>
                      <td>
                        <div className="inner_cell">
                          {operationStatus.find(equalTo(OperationStatus.ON)) ? (
                            <>운영 가능</>
                          ) : (
                            <CreativeDashboardTitleTooltip
                              status={operationStatus}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                    {creative.creativeType === CreativeTypes.BASIC && (
                      <tr>
                        <th>
                          <div className="inner_cell">유형</div>
                        </th>
                        <td>
                          <div className="inner_cell">
                            기본{creative.assets.length > 0 && '+확장'}
                          </div>
                        </td>
                      </tr>
                    )}
                    {!creative.deleted && (
                      <tr>
                        <th>
                          <div className="inner_cell">미리보기</div>
                        </th>
                        <td>
                          <div className="inner_cell">
                            <NoneAnchor
                              className="link_budget"
                              onClick={() => {
                                dispatch(
                                  showCreativePreview(creative.creativeId)
                                )
                              }}>
                              미리보기
                            </NoneAnchor>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}
export default CreativeInfo
